(function () {
  const FEATURED_PRODUCT_ANCHOR = 'mm-featured-product';

  function formatMoney(cents, format, currency) {
    if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents, format || '${{amount}}');
    }

    return new Intl.NumberFormat(undefined, {
      style: 'currency',
      currency: currency || 'USD',
    }).format(cents / 100);
  }

  function parseFormatKeyFromHashPart(hashPart) {
    if (!hashPart || !hashPart.startsWith(FEATURED_PRODUCT_ANCHOR)) return null;

    const queryIndex = hashPart.indexOf('?');
    if (queryIndex === -1) return null;

    return new URLSearchParams(hashPart.slice(queryIndex + 1)).get('format');
  }

  function parseFormatKeyFromHref(href) {
    if (!href || !href.includes(FEATURED_PRODUCT_ANCHOR)) return null;

    const hashIndex = href.indexOf('#');
    if (hashIndex === -1) return null;

    return parseFormatKeyFromHashPart(href.slice(hashIndex + 1));
  }

  function parseFormatKeyFromLocation() {
    return parseFormatKeyFromHashPart(window.location.hash.replace(/^#/, ''));
  }

  function applyFormatToAllBuyBoxes(formatKey) {
    if (!formatKey) return;

    document.querySelectorAll('[data-mcb-root]').forEach((root) => {
      if (typeof root.applyFormatByKey === 'function') {
        root.applyFormatByKey(formatKey);
      }
    });
  }

  function initSection(root) {
    const sectionId = root.dataset.sectionId;
    if (!sectionId) return;

    const dataEl = root.querySelector('[data-mcb-format-data]');
    if (!dataEl) return;

    const formats = JSON.parse(dataEl.textContent);
    if (!formats.length) return;

    const moneyFormat = root.dataset.moneyFormat || '${{amount}}';
    const currency = root.dataset.currency || 'USD';

    const formatButtons = root.querySelectorAll('[data-mcb-format]');
    const flavorWrap = root.querySelector('[data-mcb-flavors]');
    const purchaseLabel = root.querySelector('[data-mcb-purchase-label]');
    const galleryPanels = root.querySelectorAll('[data-mcb-gallery-panel]');
    const formPanels = root.querySelectorAll('[data-mcb-form-panel]');
    const onetimePriceEl = root.querySelector('[data-mcb-onetime-price]');
    const subscribePriceEl = root.querySelector('[data-mcb-subscribe-price]');
    const purchaseOptions = root.querySelectorAll('[data-mcb-purchase-option]');
    const purchaseInputs = root.querySelectorAll(`input[name="purchase-type-${sectionId}"]`);

    let activeFormatId = formats[0].id;
    let activeVariantId = formats[0].variants[0]?.id;

    function getActiveFormat() {
      return formats.find((format) => format.id === activeFormatId) || formats[0];
    }

    function getActiveVariant() {
      const format = getActiveFormat();
      return format.variants.find((variant) => variant.id === activeVariantId) || format.variants[0];
    }

    function findFormatByKey(key) {
      if (!key) return null;

      const normalized = key.toLowerCase().trim();
      return (
        formats.find(
          (format) =>
            (format.key && format.key === normalized) ||
            (format.label && format.label.toLowerCase().trim() === normalized)
        ) || null
      );
    }

    function getActiveFormPanel() {
      return root.querySelector(`[data-mcb-form-panel="${activeFormatId}"]`);
    }

    function getActiveFormFields() {
      const panel = getActiveFormPanel();
      if (!panel) return {};

      return {
        variantInput: panel.querySelector('[data-mcb-variant-id]'),
        sellingPlanInput: panel.querySelector('[data-mcb-selling-plan]'),
        atcButton: panel.querySelector('[data-mcb-atc]'),
      };
    }

    function setPurchaseType(type) {
      purchaseOptions.forEach((option) => {
        option.classList.toggle('is-selected', option.dataset.mcbPurchaseOption === type);
      });

      const variant = getActiveVariant();
      const { sellingPlanInput } = getActiveFormFields();
      if (!sellingPlanInput) return;

      if (type === 'subscription' && variant?.selling_plan_id) {
        sellingPlanInput.value = variant.selling_plan_id;
        sellingPlanInput.setAttribute('name', 'selling_plan');
        sellingPlanInput.removeAttribute('disabled');
      } else {
        sellingPlanInput.value = '';
        sellingPlanInput.removeAttribute('name');
        sellingPlanInput.setAttribute('disabled', 'disabled');
      }
    }

    function getSelectedPurchaseType() {
      const checked = root.querySelector(`input[name="purchase-type-${sectionId}"]:checked`);
      return checked ? checked.value : 'subscription';
    }

    function updatePrices(variant) {
      if (!variant) return;

      if (onetimePriceEl) {
        onetimePriceEl.textContent = formatMoney(variant.price, moneyFormat, currency);
      }

      if (subscribePriceEl) {
        subscribePriceEl.textContent = formatMoney(
          variant.selling_plan_price != null ? variant.selling_plan_price : variant.price,
          moneyFormat,
          currency
        );
      }
    }

    function updateForm(variant) {
      if (!variant) return;

      const { variantInput, atcButton } = getActiveFormFields();
      const atcLabel = atcButton?.dataset.mcbAtcLabel || 'Add to cart';

      if (variantInput) {
        variantInput.value = variant.id;
        variantInput.disabled = !variant.available;
      }

      if (atcButton) {
        atcButton.disabled = !variant.available;
        const label = atcButton.querySelector('[data-mcb-atc-text]');
        if (label) {
          label.textContent = variant.available
            ? atcLabel
            : window.variantStrings?.soldOut || 'Sold out';
        }
      }

      updatePrices(variant);
      setPurchaseType(getSelectedPurchaseType());
    }

    function getActiveGalleryPanel() {
      return root.querySelector(`[data-mcb-gallery-panel="${activeFormatId}"]`);
    }

    function getGallerySlides(panel) {
      const galleryPanel = panel || getActiveGalleryPanel();
      if (!galleryPanel) return [];

      return [...galleryPanel.querySelectorAll('[data-mcb-slide]')].filter((slide) => !slide.hidden);
    }

    function getGalleryTrack(panel) {
      const galleryPanel = panel || getActiveGalleryPanel();
      return galleryPanel?.querySelector('[data-mcb-gallery-track]') || null;
    }

    function scrollContainerToChild(container, child, behavior = 'smooth') {
      if (!container || !child) return;

      const targetScrollLeft = child.offsetLeft;

      if (behavior === 'auto') {
        container.scrollLeft = targetScrollLeft;
        return;
      }

      container.scrollTo({ left: targetScrollLeft, behavior });
    }

    function scrollThumbIntoView(panel, mediaId, behavior = 'smooth') {
      const thumbsContainer = panel.querySelector('.mm-creatine-buy-box__thumbs');
      const thumb = panel.querySelector(`[data-mcb-thumb][data-media-id="${mediaId}"]`);
      if (!thumbsContainer || !thumb || thumb.hidden) return;

      scrollContainerToChild(thumbsContainer, thumb, behavior);
    }

    function setActiveGallerySlide(panel, mediaId) {
      if (!panel) return;

      panel.querySelectorAll('[data-mcb-slide]').forEach((slide) => {
        slide.classList.toggle('is-active', Number(slide.dataset.mediaId) === Number(mediaId));
      });

      panel.querySelectorAll('[data-mcb-thumb]').forEach((thumb) => {
        thumb.classList.toggle('is-active', Number(thumb.dataset.mediaId) === Number(mediaId));
      });
    }

    function scrollToMedia(panel, mediaId, behavior = 'smooth') {
      if (!panel) return;

      const track = getGalleryTrack(panel);
      const slide = getGallerySlides(panel).find((item) => Number(item.dataset.mediaId) === Number(mediaId));
      if (!track || !slide) return;

      scrollContainerToChild(track, slide, behavior);
      setActiveGallerySlide(panel, mediaId);
      scrollThumbIntoView(panel, mediaId, behavior);
    }

    function syncActiveSlideFromScroll(panel) {
      const track = getGalleryTrack(panel);
      const slides = getGallerySlides(panel);
      if (!track || !slides.length) return;

      const trackRect = track.getBoundingClientRect();
      const trackCenter = trackRect.left + trackRect.width / 2;

      let closestSlide = slides[0];
      let closestDistance = Infinity;

      slides.forEach((slide) => {
        const slideRect = slide.getBoundingClientRect();
        const slideCenter = slideRect.left + slideRect.width / 2;
        const distance = Math.abs(slideCenter - trackCenter);

        if (distance < closestDistance) {
          closestDistance = distance;
          closestSlide = slide;
        }
      });

      const mediaId = Number(closestSlide.dataset.mediaId);
      setActiveGallerySlide(panel, mediaId);
      scrollThumbIntoView(panel, mediaId, 'smooth');
    }

    function updateGalleryForVariant(variant) {
      const panel = getActiveGalleryPanel();
      if (!panel || !variant) return;

      const mediaId = variant.featured_media_id;
      if (mediaId) {
        scrollToMedia(panel, mediaId, 'auto');
        return;
      }

      const firstSlide = getGallerySlides(panel)[0];
      if (firstSlide) {
        scrollToMedia(panel, Number(firstSlide.dataset.mediaId), 'auto');
      }
    }

    function bindGalleryPanel(panel) {
      const track = getGalleryTrack(panel);
      if (!track) return;

      let scrollTimeout;

      track.addEventListener('scroll', () => {
        window.clearTimeout(scrollTimeout);
        scrollTimeout = window.setTimeout(() => syncActiveSlideFromScroll(panel), 80);
      });

      track.addEventListener('keydown', (event) => {
        const slides = getGallerySlides(panel);
        if (slides.length < 2) return;

        const activeIndex = slides.findIndex((slide) => slide.classList.contains('is-active'));
        let nextIndex = activeIndex;

        if (event.key === 'ArrowRight') {
          nextIndex = activeIndex < slides.length - 1 ? activeIndex + 1 : 0;
        } else if (event.key === 'ArrowLeft') {
          nextIndex = activeIndex > 0 ? activeIndex - 1 : slides.length - 1;
        } else {
          return;
        }

        event.preventDefault();
        scrollToMedia(panel, Number(slides[nextIndex].dataset.mediaId));
      });

      panel.querySelectorAll('[data-mcb-thumb]').forEach((thumb) => {
        thumb.addEventListener('click', () => {
          scrollToMedia(panel, Number(thumb.dataset.mediaId));
        });
      });
    }

    function renderFlavors(format) {
      if (!flavorWrap) return;

      flavorWrap.innerHTML = '';

      format.variants.forEach((variant, index) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'mm-creatine-buy-box__pill mm-creatine-buy-box__pill--flavor';
        button.dataset.mcbFlavor = variant.id;
        button.textContent = variant.label;

        if (variant.id === activeVariantId || (index === 0 && !format.variants.some((item) => item.id === activeVariantId))) {
          button.classList.add('is-selected');
          activeVariantId = variant.id;
        }

        button.addEventListener('click', () => {
          activeVariantId = variant.id;
          flavorWrap.querySelectorAll('[data-mcb-flavor]').forEach((pill) => {
            pill.classList.toggle('is-selected', Number(pill.dataset.mcbFlavor) === variant.id);
          });
          updateForm(variant);
          updateGalleryForVariant(variant);
        });

        flavorWrap.appendChild(button);
      });
    }

    function setActiveFormat(formatId) {
      activeFormatId = formatId;
      const format = getActiveFormat();
      activeVariantId = format.variants[0]?.id;

      formatButtons.forEach((button) => {
        button.classList.toggle('is-selected', button.dataset.mcbFormat === formatId);
      });

      galleryPanels.forEach((panel) => {
        panel.hidden = panel.dataset.mcbGalleryPanel !== formatId;
      });

      formPanels.forEach((panel) => {
        panel.hidden = panel.dataset.mcbFormPanel !== formatId;
      });

      if (purchaseLabel) {
        purchaseLabel.textContent = `${format.label}:`;
      }

      renderFlavors(format);
      updateForm(getActiveVariant());
      updateGalleryForVariant(getActiveVariant());
    }

    root.applyFormatByKey = (key) => {
      const format = findFormatByKey(key);
      if (format) setActiveFormat(format.id);
    };

    formatButtons.forEach((button) => {
      button.addEventListener('click', () => {
        setActiveFormat(button.dataset.mcbFormat);
      });
    });

    purchaseOptions.forEach((option) => {
      option.addEventListener('click', () => {
        const input = option.querySelector('input');
        if (!input) return;
        input.checked = true;
        setPurchaseType(input.value);
      });
    });

    purchaseInputs.forEach((input) => {
      input.addEventListener('change', () => {
        if (input.checked) setPurchaseType(input.value);
      });
    });

    galleryPanels.forEach((panel) => {
      bindGalleryPanel(panel);
    });

    setActiveFormat(activeFormatId);
    setPurchaseType(getSelectedPurchaseType());

    const hashFormatKey = parseFormatKeyFromLocation();
    if (hashFormatKey) {
      root.applyFormatByKey(hashFormatKey);
    }

    formPanels.forEach((panel) => {
      const form = panel.querySelector('form');
      if (!form) return;

      form.addEventListener(
        'submit',
        () => {
          setPurchaseType(getSelectedPurchaseType());
        },
        true
      );
    });
  }

  function initAll() {
    document.querySelectorAll('[data-mcb-root]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-mcb-root]').forEach(initSection);
  });

  document.addEventListener('click', (event) => {
    const link = event.target.closest(`a[href*="${FEATURED_PRODUCT_ANCHOR}"]`);
    if (!link) return;

    const formatKey = parseFormatKeyFromHref(link.getAttribute('href'));
    if (!formatKey) return;

    event.preventDefault();

    const targetHash = `${FEATURED_PRODUCT_ANCHOR}?format=${encodeURIComponent(formatKey)}`;
    if (window.location.hash.replace(/^#/, '') !== targetHash) {
      window.history.pushState(null, '', `#${targetHash}`);
    }

    document.getElementById(FEATURED_PRODUCT_ANCHOR)?.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
    });
    applyFormatToAllBuyBoxes(formatKey);
  });

  window.addEventListener('hashchange', () => {
    const formatKey = parseFormatKeyFromLocation();
    if (formatKey) applyFormatToAllBuyBoxes(formatKey);
  });
})();
